<template>
    <table ref="table" class="display user-datatable nowrap" style="width: 100%;">
        <thead>
            <tr>
                <th v-for="(column, index) in columns" v-html="column.name">

                </th>
            </tr>
        </thead>
    </table>
</template>

<script>
    export default {
        props: ['columns', 'ajax', 'order','serverSide'],
        methods: {
            editProperty(data){
                console.log(data)
            }
        },
        mounted: function() {
            let table = $(this.$refs.table).dataTable({
                ajax: this.ajax,
                scrollY: false,
                scrollX: true,
                serverSide:this.serverSide,
                searching: false,
                dom: '<"top">rt<"bottom"<"left-actions"li>p><"clear">',
                columnDefs: [],
                select: {
                    style: "os",
                    selector: "td:first-child",
                },
                order: [[this.order, "desc"]],
                columns: this.columns,
            });
            const self = this
            $('tbody', this.$refs.table).on('click', '.custom-placeholder', function(){
                const cell = table.api().cell($(this).closest("td"));
                self.editProperty(cell.data())
            });
        }
    }
</script> 